import { render, staticRenderFns } from "./CompilatoreQuestionarioInBlocks.vue?vue&type=template&id=99f4bb50&scoped=true"
import script from "./CompilatoreQuestionarioInBlocks.vue?vue&type=script&lang=js"
export * from "./CompilatoreQuestionarioInBlocks.vue?vue&type=script&lang=js"
import style0 from "./CompilatoreQuestionarioInBlocks.vue?vue&type=style&index=0&id=99f4bb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f4bb50",
  null
  
)

export default component.exports